const Debug = require('../util/debug')('storage');

/**
 * In-memory implementation of Storage.
 */
class MemoryStorage {
    constructor() {
        this._items = {};
    }

    getItem(key) {
        return this._items[key] || null;
    }

    setItem(key, value) {
        this._items[key] = String(value);
    }

    clear() {
        this._items = {};
    }

    removeItem(key) {
        delete this._items[key];
    }

    key(n) {
        return Object.keys(this._items)[n] || null;
    }
}

/**
 * Check to see if the specified Storage works as expected.
 */
const checkStorage = (storage) => {
    try {
        if (!storage) {
            return false;
        }

        const key = '__test_storage_support__';

        storage.setItem(key, key);

        if (storage.getItem(key) !== key) {
            return false;
        }

        storage.removeItem(key);

        return true;
    } catch(e) {
        return false;
    }
};

/**
 * Get built-in storage by name, or default to MemoryStorage.
 */
const getStorage = (storageName) => {
    // This try-catch may seem unnecessary, but Safari with disabled cookies
    // will throw when trying to access a Storage object.
    try {
        const storage = window[storageName];
        if (checkStorage(storage)) {
            return storage;
        }
    } catch(e) {}

    return new MemoryStorage();
};

export const sessionStorage = getStorage('sessionStorage');
export const localStorage = getStorage('localStorage');




// WEBPACK FOOTER //
// ./src/js/util/storage.js